export default "__VITE_ASSET__1f65eee9__$_?component__"